<template>
  <div class="login-class" style="height: calc(100vh);">
    <el-row>
      <el-col :span="16" class="login-links">
        <div style="width: 100%">
          <div style="float: left">
            <img src="/logo.png" class="login-logo" />
            <span class="login-h ml-4">{{ $t(language.login_name) }}</span>
          </div>
        </div>
      </el-col>
    </el-row>
    <b-card>
      <GuestVend v-if="is_vend"></GuestVend>
      <GuestCust v-else></GuestCust>
    </b-card>

    <el-row class="login-footer d-md-down-none">
      <el-col :span="24" class="pl-2 pr-2">
        <strong class="guest-strong">
          Copyright © {{ plantSetting.copy_right }} &nbsp; Stora Enso
          &nbsp;&nbsp;&nbsp;&nbsp;</strong>
        <strong class="guest-strong">
          <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #939393">冀ICP备06025035号-2</a></strong>

        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=13028302000150" strong
          class="ml-5 guest-strong"><img src="../../../public/img/police.png" style="float: left;margin-top:10px" />
          <p class="guest-strong">
            冀公网安备 13028302000150号
          </p>
        </a>
        <strong class="guest-strong-right">CPSP &nbsp; Version {{ plantSetting.version }}</strong>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// -- import * as _ from "lodash-es"
import language from "../../shared/language"
import plantSetting from "../../shared/plant_setting"
import GuestVend from "./GuestVend"
import GuestCust from "./GuestCust"
import * as localStorageMgr from "../../shared/localStorageMgr"

export default {
  name: "GuestLogin",
  components: {
    GuestVend,
    GuestCust,
  },
  data() {
    return {
      plantSetting: plantSetting,
      logobg_style:
        "background: url(/img/dashbord-bg.jpg) no-repeat; background-size: 100% !important;",
      language: language.login,
      locale: "zh-CN",
      base_url: "https://www.storaenso.com/",
      lang_data: {},
      is_vend: true,
    }
  },
  beforeCreate() {
    // localStorage.removeItem(localStorageMgr.data.plant_idx);
    // localStorage.removeItem(localStorageMgr.data.access_token);
    // sessionStorage.removeItem(sessionStorageMgr.data.cpsp_store);
  },

  async created() {
    if (window.location.search && window.location.search.indexOf("?k=") > -1) {
      localStorageMgr.clear()
      window.location.href = "/pages/GuestLogin" + window.location.search
    }
    let token = localStorageMgr.get(localStorageMgr.data.pub_guest_token)
    if (!token)
      window.location.href = "/pages/GuestLogin" + window.location.search
    else {
      let guest_info = JSON.parse(this.ls.get(localStorageMgr.data.guest_info))
      this.is_vend = guest_info.issuer_type == "vender"
      await this.$loadLanguageAsync(this.locale, this.$i18n)
    }
  },

  mounted() {
    // this.$refs.input_phone.focus();
  },
  methods: {},
}
</script>

<style scoped>
@media (max-width: 600px) {
  .el-menu-demo {
    margin-right: 0.8rem;
  }

  .login-logo {
    width: auto;
    height: 30px;
  }

  .login-h {
    color: #202020;
    font-size: 1.2rem;
    font-weight: 700;
  }

  .login-bg {
    height: 250px;
    padding-top: 6rem;
    text-align: center;
    background: url("/login-bg.jpg") no-repeat;
    background-size: 100% auto;
  }

  .login-info {
    height: 200px;
    width: 23rem;
    margin: 3.5rem auto !important;
  }

  .login-lang-icon {
    font-size: 1rem;
    margin-top: 0.5rem;
  }

  .text-muted {
    line-height: 0.2rem !important;
  }

  .login-input-group {
    margin-bottom: 0.5rem !important;
  }

  .login-links {
    padding-left: 0.8rem;
    padding-right: 0.8rem;
    width: 100%;
    /* margin-top: 6rem; */
  }

  .el-row {
    margin-bottom: 20px;
    line-height: 60px;
    background-color: #fff;
  }

  .el-col {
    border-radius: 4px;
  }

  .bg-purple-dark {
    background: #fff;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }

  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }

  .alink {
    color: #202020;
    font-size: 0.95rem;
    font-weight: 700;
    border-bottom: 3px solid #fdc80a;
    padding-bottom: 3px;
    text-decoration: none;
    margin: 0 10px;
  }

  .alink:hover {
    color: #2020205e;
  }

  .login-class .el-menu.el-menu--horizontal {
    border-bottom: none;
    height: 60px;
  }

  .login-class .el-menu--horizontal>.el-submenu .el-submenu__title {
    height: 60px;
    line-height: 60px;
    border-bottom: 2px solid transparent;
    color: #202020;
    font-size: 10px;
    font-weight: 700;
    padding: 0;
  }

  .login-class .el-menu--horizontal:hover {
    color: blue;
  }

  .login-class a {
    color: inherit;
    text-decoration: none;
  }

  .login-class .el-row {
    margin-bottom: 0;
  }

  ._2LDS--h2Heading {
    color: #202020;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1.6rem;
    padding: 0 0 0 23px;
    position: relative;
    margin: 0 0 20px;
    width: 100%;
  }

  ._2LDS--h2Heading:before {
    background-color: #118bd6;
    content: "";
    display: inline-block;
    height: 100%;
    left: 0;
    position: absolute;
    width: 5px;
  }

  ._3Wy7--columnCount3 {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    list-style: none;
    margin: 0;
    padding: 0;
    position: relative;
  }

  ._20Eh--width3 {
    flex: 0 1 31%;
    min-width: 0;
    line-height: 1.8rem;
  }

  ._2Jhy--ctaLink {
    display: flex;
    flex: 1;
    font-weight: 700;
    font-size: 16px;
    margin: 0 0 5px;
  }

  ._2rl0--root {
    text-decoration: none;
  }

  ._1nlS--link {
    align-items: center;
    display: flex;
  }

  ._2qLO--root {
    text-decoration: none;
  }

  .zKay--root {
    display: inline-block;
    height: 15px;
    width: 15px;
  }

  .eE0T--iconBefore {
    margin: -2px 7px 0 0;
  }

  ._2_nP--yellowIcon {
    stroke: #fdc80a;
  }

  ._3fVj--icon {
    fill: none;
    line-height: 0;
    stroke: #fdc80a;
    stroke-width: 2;
    vertical-align: middle;
  }

  ._3ipe--arrowHeadRight {
    stroke-width: 4;
  }

  ._1vQq--svg {
    display: inline-block;
    height: inherit;
    speak: none;
    width: inherit;
  }

  .footer-link {
    margin-top: 150px;
    width: 100%;
    /* position: fixed;
    bottom: 0; */
  }

  .login-footer {
    width: 100%;
    background-color: #f8f8f9;
    line-height: 40px;
    margin-top: 20px;
    padding-left: 15px;
  }
}

@media (min-width: 600px) {
  .login-logo {
    width: auto;
    height: 60px;
    margin-left: 1rem;
  }

  .login-h {
    color: #202020;
    font-size: 1.5rem;
    font-weight: 700;
  }

  .text-muted {
    line-height: 0rem !important;
  }

  .login-bg {
    height: 500px;
    padding-top: 20rem;
    background: url("/login-bg.jpg") no-repeat;
    background-size: 100% auto;
  }

  .login-info {
    height: 250px;
    width: 450px;
  }

  .el-row {
    margin-bottom: 20px;
    line-height: 80px;
    background-color: #fff;
  }

  .el-col {
    border-radius: 4px;
  }

  .bg-purple-dark {
    background: #fff;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }

  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }

  /* .login-class {
  font-size: 16px;
  font-weight: 700;
} */
  /* .login-class .el-menu.el-menu--horizontal {
  border-bottom: none;
}
.login-class .el-menu .el-menu-item {
  float: left;
  height: 60px;
  line-height: 80px;
  margin: 0;
  border-bottom: 3px solid #fdc80a;
  color: #202020;
  font-size: 16px;
  font-weight: 700;
} */
  .alink {
    color: #202020;
    font-size: 16px;
    font-weight: 700;
    border-bottom: 3px solid #fdc80a;
    padding-bottom: 3px;
    text-decoration: none;
    margin: 0 20px;
  }

  .alink:hover {
    color: #2020205e;
  }

  .login-class .el-menu.el-menu--horizontal {
    border-bottom: none;
    height: 80px;
  }

  .login-class .el-menu--horizontal>.el-submenu .el-submenu__title {
    height: 80px;
    line-height: 80px;
    border-bottom: 2px solid transparent;
    color: #202020;
    font-size: 10px;
    font-weight: 700;
    padding: 0;
  }

  .login-class .el-menu--horizontal:hover {
    color: blue;
  }

  .login-class a {
    color: inherit;
    text-decoration: none;
  }

  .login-class .el-row {
    margin-bottom: 0;
  }

  ._2LDS--h2Heading {
    color: #202020;
    font-size: 28px;
    font-weight: 700;
    line-height: 32px;
    padding: 0 0 0 23px;
    position: relative;
    margin: 0 0 20px;
    width: 100%;
  }

  ._2LDS--h2Heading:before {
    background-color: #118bd6;
    content: "";
    display: inline-block;
    height: 100%;
    left: 0;
    position: absolute;
    width: 5px;
  }

  ._3Wy7--columnCount3 {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    list-style: none;
    margin: 0;
    padding: 0;
    position: relative;
  }

  ._20Eh--width3 {
    flex: 0 1 31%;
    min-width: 0;
    line-height: 3rem;
  }

  ._2Jhy--ctaLink {
    display: flex;
    flex: 1;
    font-weight: 700;
    font-size: 16px;
    margin: 0 0 5px;
  }

  ._2rl0--root {
    text-decoration: none;
  }

  ._1nlS--link {
    align-items: center;
    display: flex;
  }

  ._2qLO--root {
    text-decoration: none;
  }

  .zKay--root {
    display: inline-block;
    height: 15px;
    width: 15px;
  }

  .eE0T--iconBefore {
    margin: -2px 7px 0 0;
  }

  ._2_nP--yellowIcon {
    stroke: #fdc80a;
  }

  ._3fVj--icon {
    fill: none;
    line-height: 0;
    stroke: #fdc80a;
    stroke-width: 2;
    vertical-align: middle;
  }

  ._3ipe--arrowHeadRight {
    stroke-width: 4;
  }

  ._1vQq--svg {
    display: inline-block;
    height: inherit;
    speak: none;
    width: inherit;
  }

  .footer-link {
    margin-top: 150px;
    width: 100%;
  }

  .login-footer {
    width: 100%;
    background-color: #f8f8f9;
    line-height: 40px;
    margin-top: 20px;
  }
}

@media (min-height: 900px) {
  .footer-link {
    margin-top: 150px;
    width: 100%;
  }

  .login-footer {
    width: 100%;
    background-color: #f8f8f9;
    line-height: 40px;
    margin-top: 20px;
    position: fixed;
    bottom: 0;
  }
}

.guest-strong {
  float: left;
  height: 40px;
  line-height: 40px;
  margin: 0px 0px 0px 2px;
  color: #939393;
}

.guest-strong-right {
  float: right;
  height: 40px;
  line-height: 40px;
  margin: 0px 0px 0px 2px;
  color: #939393;
}

.login-class :deep(.card) {
  height: calc(100vh - 83px - 40px) !important;
  margin: 0px !important;
}

.login-class :deep(.login-footer) {
  margin: 0px !important;
}
</style>
